module.exports = __webpack_public_path__ + "img/icon_map_3_5_yj_c.12543d21.png";